var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
// Redux
import { connect } from "react-redux";
import { push } from "react-router-redux";
// Components
import { ErrorMessageBlock } from "common/ui/components/error/ErrorMessageBlock";
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
    };
}
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let BadUrlMode = class BadUrlMode extends React.Component {
    //--
    onLocalHomeClick() {
        this.props.dispatch(push("/"));
    }
    //--
    render() {
        return (React.createElement(ErrorMessageBlock, { title: "We're sorry, the page could not be found.", subTitle: "The page has probably moved or no longer exists.", buttonText: "Home", buttonCallback: () => this.onLocalHomeClick() }));
    }
};
BadUrlMode = __decorate([
    connect(null, mapDispatchToProps)
], BadUrlMode);
export { BadUrlMode };
